<template>

    <div class="wizard-component search-box" v-if="true">
        <p class="subject">{{ $t('digital.tabs.choosetenant.bysearch.label') }}</p>
        <div class="box">
            <div class="search-field">
                <SvgIcon icon="search"/>
                <form>
                    <input
                        type="text"
                        v-model="search"
                        :placeholder="$t('choose-tenant.search.label')"
                    />
                </form>
            </div>

            <ul v-if="invitationsWithoutSelected.length > 0">
                <li v-for="invitation in invitationsWithoutSelected" @click.prevent="select(invitation)">
                    <div class="content">
                        <p>{{ invitation.email }}</p>
                    </div>

                    <div v-if="invitation.email === value.email" class="selector">
                        <div class="checkmark">
                            <SvgIcon icon="checkmark"/>
                        </div>
                    </div>
                </li>
            </ul>
            <div v-else class="no-content">{{ $t('screenings.none.headline') }}</div>
            <div class="fade"></div>
        </div>
    </div>

</template>


<script>
export default {
    props: ['value', 'invitations', 'selected'],
    filters: {},
    data: () => ({
        search: '',
    }),
    methods: {
        select: function (invitation) {
            this.$emit('input', {
                email: invitation.email
            });
        }
    },
    computed: {
        invitationsWithoutSelected: function () {
            let emails = _.flatMap(this.selected, (item) => item.email);

            return _.filter(this.invitations, (invitation) => {
                return (emails.indexOf(invitation.email) < 0 || this.value.email === invitation.email)
                    && invitation.email.includes(this.search);
            });
        }
    },
    mounted() {

    },
}
</script>


<style></style>
